<template>
  <view-wrap class="bg-light">
    <div id="faq">
      <h1 class="h0 caps">FAQ</h1>
      <!-- <ul class="h4">
        <li>
          <h6>
            <button class="link h4" v-scroll-to="{ el: '#what-does-it-do', offset: 200 }">What does Fantasy Sports Toolbox do?</button>
          </h6>
        </li>
        <li>
          <h6>
            <button class="link h4" v-scroll-to="{ el: '#leagues', offset: 200 }">What leagues are supported?</button>
          </h6>
        </li>
        <li>
          <h6>
            <button class="link h4" v-scroll-to="{ el: '#suggestions', offset: 200 }">I have an idea for a new tool - how can I suggest it?</button>
          </h6>
        </li>
        <li>
          <h6>
            <button class="link h4" v-scroll-to="{ el: '#cost', offset: 200 }">How much does it cost?</button>
          </h6>
        </li>
        <li>
          <h6>
            <button class="link h4" v-scroll-to="{ el: '#signin', offset: 200 }">Why does the website ask me to sign in again, at times?</button>
          </h6>
        </li>
      </ul> -->

      <div class="solutions">
        <div id="what-does-it-do" class="solution">
          <h3>What does Fantasy Falcon do?</h3>
          <p>FF is a set of tools that help you analyze your team's performance on Yahoo fantasy basketball.</p>
          <p>Our hope is that these tools provide valuable insights, and save you 30 - 60 mins each week.</p>
        </div>
        <div id="leagues" class="solution">
          <h3>What leagues are supported?</h3>
          <p>We currently support head-to-head leagues on Yahoo! Fantasy Basketball. We plan to support other formats and leagues in the upcoming months.</p>
          <p>Cast a vote for a league you want us to support via the 'Contact Us' link up top, or shoot us a note on twitter <a :href="external.twitter" target="_blank">@fantasysportstoolbox</a>.</p>
        </div>
        <div id="suggestions" class="solution">
          <h3>I have an idea for a new tool - how can I suggest it?</h3>
          <p>We'd love to continue to build powerful tools to save you time. Just click on the 'Contact Us' link up top and shoot us a note. If you have an example spreadsheet or screenshot, please do attach it!</p>
          <p>You can also reach out to us on twitter at <a :href="external.twitter" target="_blank">@fantasysportstoolbox</a>.</p>
        </div>
        <div id="cost" class="solution">
          <h3>How much does it cost?</h3>
          <p>At the moment, all tools are completely free. In the future, we may decide to charge a small fee to cover the costs of running the website. And our coffee consumption ;)</p>
        </div>
        <div id="signin" class="solution">
          <h3>Why does the website ask me to sign in again, at times?</h3>
          <p>We currently don't store your username or password, for security reasons. Instead, we sign you in via Yahoo which requires us to re-authenticate you every time we need to grab new data.</p>
        </div>
      </div>
    </div>
  </view-wrap>
</template>

<script>

export default {
  name: "faq",
  data () {
    return {}
  },
  components: {},
  methods: {}
};
</script>

<style src="./faq.styl" lang="stylus" scoped></style>
